"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _withScopeId = (n) => ((0, vue_2.pushScopeId)("data-v-e9244d58"), n = n(), (0, vue_2.popScopeId)(), n);
const _hoisted_1 = { class: "mt-15" };
const _hoisted_2 = { class: "oplus-table-wrapper" };
const _hoisted_3 = { class: "oplus-table" };
const _hoisted_4 = { class: "small-cell" };
const _hoisted_5 = { class: "h-100 d-flex flex-center c-hand handle" };
const _hoisted_6 = { class: "text-left" };
const _hoisted_7 = { class: "h-100 d-flex flex-center flex-gap" };
const _hoisted_8 = ["for"];
const _hoisted_9 = ["id", "value", "onChange"];
const _hoisted_10 = { class: "h-100 d-flex flex-center flex-gap" };
const _hoisted_11 = ["for"];
const _hoisted_12 = ["id", "value", "onChange"];
const _hoisted_13 = { class: "small-cell" };
const _hoisted_14 = { class: "h-100 d-flex flex-center c-hand disabled-btn" };
const _hoisted_15 = { class: "text-left" };
const _hoisted_16 = { class: "h-100 d-flex flex-center flex-gap" };
const _hoisted_17 = ["for"];
const _hoisted_18 = ["id", "value", "onChange"];
const _hoisted_19 = { class: "h-100 d-flex flex-center flex-gap" };
const _hoisted_20 = ["for"];
const _hoisted_21 = ["id", "value", "onChange"];
const vue_3 = require("vue");
const SortIcon_vue_1 = __importDefault(require("../../vue/icons/SortIcon.vue"));
const sortablejs_1 = __importDefault(require("sortablejs"));
const sortable_1 = require("../../model/v1/sortable");
const roles_1 = require("../../js/roles");
exports.default = (0, vue_1.defineComponent)({
    __name: 'RoleRequiredByStaff',
    setup(__props) {
        const role = (0, vue_3.inject)("roleView");
        const requiredByDayTable = (0, vue_3.ref)(null);
        const employees = (0, vue_3.ref)(role?.value.employeesData ?? []);
        const employeesOrder = (0, vue_3.ref)(role?.value.employeesOrder ?? []);
        const joinedEmployees = (0, vue_3.computed)(() => {
            let out = [];
            const joined = employees.value?.filter(e => e.weekly > 0 || e.monthly > 0);
            const empMap = new Map(employeesOrder.value.map((val, idx) => [val, idx]));
            if (employeesOrder.value.length) {
                out = joined.sort((a, b) => (empMap.get(a.id) ?? Infinity) - (empMap.get(b.id) ?? Infinity));
            }
            else {
                out = joined;
            }
            return out;
        });
        const unjoinedEmployees = (0, vue_3.computed)(() => {
            return employees.value?.filter(e => e.weekly === 0 && e.monthly === 0) || [];
        });
        function handleWeeklyChange(event, user) {
            const target = event.target;
            const value = target.value;
            const userIndex = employeesOrder.value.findIndex(eId => eId === user.id);
            user.weekly = parseInt(value) ?? 0;
            if (user.weekly && userIndex === -1) {
                employeesOrder.value.push(user.id);
            }
            if (!user.weekly && userIndex !== -1) {
                employeesOrder.value.splice(userIndex, 1);
            }
            getDataAndUpdate(user);
        }
        function handleMonthlyChange(event, user) {
            const target = event.target;
            const value = target.value;
            const userIndex = employeesOrder.value.findIndex(eId => eId === user.id);
            user.monthly = parseInt(value) ?? 0;
            if (user.monthly && userIndex === -1) {
                employeesOrder.value.push(user.id);
            }
            if (!user.monthly && userIndex !== -1) {
                employeesOrder.value.splice(userIndex, 1);
            }
            getDataAndUpdate(user);
        }
        async function getDataAndUpdate(user) {
            if (!role) {
                return;
            }
            const { id, monthly, weekly } = user;
            const payload = {
                ID: id,
                Month: monthly,
                Week: weekly,
            };
            await (0, roles_1.handleRoleEmployeeCountUpdate)(role.value.id, payload);
        }
        function moveJoinedUser(oldIndex, newIndex) {
            if (oldIndex < 0 || oldIndex >= employeesOrder.value.length) {
                return;
            }
            if (newIndex < 0) {
                newIndex = 0;
            }
            if (newIndex >= employeesOrder.value.length) {
                newIndex = employeesOrder.value.length - 1;
            }
            const element = employeesOrder.value.splice(oldIndex, 1)[0];
            employeesOrder.value.splice(newIndex, 0, element);
        }
        (0, vue_3.onMounted)(() => {
            if (!requiredByDayTable.value) {
                return;
            }
            new sortablejs_1.default(requiredByDayTable.value, {
                ...sortable_1.roleTableSortableOptions,
                onEnd: (event) => {
                    if (!role || event.oldDraggableIndex === event.newDraggableIndex || event.oldDraggableIndex === undefined || event.newDraggableIndex === undefined) {
                        return;
                    }
                    moveJoinedUser(event.oldDraggableIndex, event.newDraggableIndex);
                    (0, roles_1.handleRoleEmployeePositionUpdate)(role.value.id, employeesOrder.value);
                },
            });
        });
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (0, vue_2.createElementVNode)("div", _hoisted_2, [
                    (0, vue_2.createElementVNode)("table", _hoisted_3, [
                        (0, vue_2.createElementVNode)("tbody", {
                            ref_key: "requiredByDayTable",
                            ref: requiredByDayTable
                        }, [
                            ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(joinedEmployees.value, (user) => {
                                return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("tr", {
                                    class: "joined-employees role-draggable",
                                    key: user.id
                                }, [
                                    (0, vue_2.createElementVNode)("td", _hoisted_4, [
                                        (0, vue_2.createElementVNode)("div", _hoisted_5, [
                                            (0, vue_2.createVNode)(SortIcon_vue_1.default)
                                        ])
                                    ]),
                                    (0, vue_2.createElementVNode)("td", null, [
                                        (0, vue_2.createElementVNode)("span", _hoisted_6, (0, vue_2.toDisplayString)(user.name), 1 /* TEXT */)
                                    ]),
                                    (0, vue_2.createElementVNode)("td", null, [
                                        (0, vue_2.createElementVNode)("div", _hoisted_7, [
                                            (0, vue_2.createElementVNode)("label", {
                                                for: `${user.id}-week`
                                            }, "週の割当日数", 8 /* PROPS */, _hoisted_8),
                                            (0, vue_2.createElementVNode)("input", {
                                                id: `${user.id}-week`,
                                                value: user.weekly,
                                                onChange: (e) => handleWeeklyChange(e, user),
                                                class: "form-input user-week",
                                                tabindex: "1",
                                                size: "3",
                                                type: "number",
                                                min: "0"
                                            }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_9)
                                        ])
                                    ]),
                                    (0, vue_2.createElementVNode)("td", null, [
                                        (0, vue_2.createElementVNode)("div", _hoisted_10, [
                                            (0, vue_2.createElementVNode)("label", {
                                                for: `${user.id}-month`
                                            }, "月の割当日数", 8 /* PROPS */, _hoisted_11),
                                            (0, vue_2.createElementVNode)("input", {
                                                id: `${user.id}-month`,
                                                value: user.monthly,
                                                onChange: (e) => handleMonthlyChange(e, user),
                                                class: "form-input user-month",
                                                tabindex: "2",
                                                size: "3",
                                                type: "number",
                                                min: "0"
                                            }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_12)
                                        ])
                                    ])
                                ]));
                            }), 128 /* KEYED_FRAGMENT */)),
                            ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(unjoinedEmployees.value, (user) => {
                                return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("tr", {
                                    class: "unjoined-employees",
                                    key: user.id
                                }, [
                                    (0, vue_2.createElementVNode)("td", _hoisted_13, [
                                        (0, vue_2.createElementVNode)("div", _hoisted_14, [
                                            (0, vue_2.createVNode)(SortIcon_vue_1.default)
                                        ])
                                    ]),
                                    (0, vue_2.createElementVNode)("td", null, [
                                        (0, vue_2.createElementVNode)("span", _hoisted_15, (0, vue_2.toDisplayString)(user.name), 1 /* TEXT */)
                                    ]),
                                    (0, vue_2.createElementVNode)("td", null, [
                                        (0, vue_2.createElementVNode)("div", _hoisted_16, [
                                            (0, vue_2.createElementVNode)("label", {
                                                for: `${user.id}-week`
                                            }, "週の割当日数", 8 /* PROPS */, _hoisted_17),
                                            (0, vue_2.createElementVNode)("input", {
                                                id: `${user.id}-week`,
                                                value: user.weekly,
                                                onChange: (e) => handleWeeklyChange(e, user),
                                                class: "form-input user-week",
                                                tabindex: "1",
                                                size: "3",
                                                type: "number",
                                                min: "0"
                                            }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_18)
                                        ])
                                    ]),
                                    (0, vue_2.createElementVNode)("td", null, [
                                        (0, vue_2.createElementVNode)("div", _hoisted_19, [
                                            (0, vue_2.createElementVNode)("label", {
                                                for: `${user.id}-month`
                                            }, "月の割当日数", 8 /* PROPS */, _hoisted_20),
                                            (0, vue_2.createElementVNode)("input", {
                                                id: `${user.id}-month`,
                                                value: user.monthly,
                                                onChange: (e) => handleMonthlyChange(e, user),
                                                class: "form-input user-month",
                                                tabindex: "2",
                                                size: "3",
                                                type: "number",
                                                min: "0"
                                            }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_21)
                                        ])
                                    ])
                                ]));
                            }), 128 /* KEYED_FRAGMENT */))
                        ], 512 /* NEED_PATCH */)
                    ])
                ])
            ]));
        };
    }
});
